<template>
    <b-button
      type="button"
      size="sm"
      variant="success"
      v-if="user.status !== this.userStatusToExclude"
      v-on:click="activateUser"
    >
      <i class="fa fa-plus" ></i> Activate
    </b-button>
</template>
<script>
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {handleErrors} from "../../../shared/utils";
    import {User} from "../../../models/User";

    const UserRepo = RepositoryFactory.get('user');

    export default {
        name: 'user-activate-button',
        props: {
            user: {
                type: Object,
                default: new User(),
            },
        },
        data() {
            return {
                userStatusToExclude: 'active',
            }
        },
        methods: {
            activateUser() {
                this.$emit('click')
                UserRepo
                    .activateUser(this.user.id)
                    .then(
                        response =>
                            (
                                this.$emit('active', response.data.data)
                            )
                    )
                    .catch(
                        response => (
                            this.returnErrors(response)
                        )
                    )
            },
            returnErrors(response) {
                this.$emit('click')
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                )
            },
        },
    }
</script>
